import { Component, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { inject, signal, computed } from '@angular/core';
import { Router } from '@angular/router';
import { LookupStore } from '@program-suite/data-common';
import { WholesalerSettingsStore } from '../data/wholesaler-settings.store';
import { GridEmitter, GridOptions, UiGridComponent } from '@program-suite/ui-grid';
import { Sort } from '@angular/material/sort';
import { ButtonComponent, ModalService, ModalType } from "@program-suite/ui";
import { TenantsGridRowViewModel } from '@program-suite/data-common/program';
import { query } from '@angular/animations';

@Component({
  selector: 'lib-wholesalers-grid',
  imports: [CommonModule, UiGridComponent],
  templateUrl: './wholesalers-grid.component.html',
  styleUrl: './wholesalers-grid.component.scss',
})
export class WholesalersGridComponent {
  wholesalerStore = inject(WholesalerSettingsStore);
  lookupStore = inject(LookupStore);
  defaultSortColumn = 'lastUpdated';
  defaultSortDirection = 'DESCENDING';
  data = computed<TenantsGridRowViewModel[]>(() => this.wholesalerStore.resource.value()?.rows ?? []);
  totalNumberOfItems = computed<number>(() =>
    this.wholesalerStore.resource.value() ? this.wholesalerStore.resource.value()?.totalCount ?? 0 : 0,
  );

  gridOptions = signal<GridOptions>({
    filterData: [
      { name: 'Search', formControlName: 'searchTerm', type: 'search' },
      { name: 'Tenant', formControlName: 'tenantId', type: 'dropdown', lookup: this.lookupStore.tenants },
    ],
    filterValues: this.wholesalerStore.filterValues,
    openFilters: true,
    columns: [

      { header: 'Company Name', controlName: 'companyName' },
      { header: 'Address', controlName: 'address' },
      { header: 'License', controlName: 'license', minWidth: '136px' },
      { header: 'Tenant Subdomain', controlName: 'tenantSubdomain' }, // minWidth: '100px'
      { header: 'Status', controlName: 'status' },
      { header: 'Created Date', controlName: 'createdDate', displayPipe: 'date' },
      { header: 'Manage', controlName: 'action', 
        actionColumnitems: [
          { type: 'icon', buttonAction: 'action',
            conditionalDisplay: { calculateDisplay: () => 'eye', column: 'status' },
            },
        ]
      }
    ],
    data: this.data,
    totalNumberOfItems: this.totalNumberOfItems,
    frontEndPagination: false,
    fetchData: false,
    displaySearch: false,
  });

  constructor(private router: Router, private modalService: ModalService) {}

  ngOnInit(): void {
    this.lookupStore.loadLookup('tenants');
    this.lookupStore.loadLookup('programs');
    // reload grid everytime this page is hit
    if (this.wholesalerStore.filterValues() !== null) {
      this.wholesalerStore.resource.reload();
    }
  }

  fetchAll(rawParams?: any) {
    const { sortOrder } = rawParams;
    const newSortOrder = this.sortField(sortOrder);
    const params = {
      ...rawParams,
      dateFrom: '',
      dateTo: '',
      SortField: newSortOrder
        ? newSortOrder.active && newSortOrder.direction
          ? newSortOrder.active
          : this.defaultSortColumn
        : this.defaultSortColumn,
      SortDirection: newSortOrder ? newSortOrder.direction ?? this.defaultSortDirection : this.defaultSortDirection,
    };
    this.wholesalerStore.setFilterValues(params);
  }

  sortField(sort: Sort) {
    let activeSort: string = this.defaultSortColumn;
    let direction: string | null = this.defaultSortDirection;
    if (sort !== null && sort !== undefined) {
      activeSort = sort.active;
      switch (true) {
        case sort.active === 'effectiveDate':
          activeSort = 'policyEffectiveDate';
          break;
      }
      switch (true) {
        case sort.direction === 'desc':
          direction = 'DESCENDING';
          break;
        case sort.direction === 'asc':
          direction = 'ASCENDING';
          break;
        case sort.direction === '':
          direction = null;
          break;
      }
    }
    return { active: activeSort, direction: direction };
  }

  async actionEvent(event: GridEmitter) {
    const data = event.data as any;
    if (event.action === 'fetchAll') {
      this.fetchAll(data);
    } else if (event.action === 'formChanges') {
      this.fetchAll(data);
    } else if (event.action === 'clearFilters') {
      this.fetchAll(data);
    } else if (event.action === 'action') {
      this.router.navigate([`/wholesale-settings`], { queryParams: { tenantId: data.tenantId } });
    } else if (event.action === 'onDestroy') {
      // on Destroy
    }
  }

  addWholesaler() {
 
  }
}
